import {Injectable} from '@angular/core';
import { Router} from '@angular/router';
import {PackagesListService} from './packages-list.service';
import {BaseResolverService} from '@abstract/base-resolver.service';
import {Package} from '../package.interface';

@Injectable()
export class PackagesListResolverService extends BaseResolverService {
    protected redirectUrl = '/packages/welcome';

    constructor(
        service: PackagesListService,
        router: Router
    ) {
        super(service, router);
    }


    processResolvedData(data: Package) {
        /**
         * Редиректим на приветствие, если нет ни одного визарда в коллеции
         */
        if (data) {
            return data;
        } else {
            this.redirect();
        }
    }
}
